import React from "react"
import type { Document } from "@contentful/rich-text-types"
import { RichTextRenderer } from "components/Contentful/RichTextRenderer"
import { RichTextFlat } from "../RichTextFlat"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import { isDocument } from "utils/isDocumentTypeGuard"

import {
  container,
  headingClass,
  smallHeadingClass,
  pinkBackground,
  lightPinkBackground,
  lightestPinkBackground,
  whiteBackground,
  yellowBackground,
  grayBackground,
} from "./LandingPageHeading.css"

type Props = {
  title: string
  headline: string
  bodyCopy?: Document | string
  backgroundColourOptional?: string
  headingSize: "Normal" | "Small"
  trackingModule: {
    modulePosition: number
  }
}

const getBackgroundColour = (colour = "white"): string => {
  const colours = {
    pink: pinkBackground,
    "light pink": lightPinkBackground,
    "lightest pink": lightestPinkBackground,
    white: whiteBackground,
    yellow: yellowBackground,
    gray: grayBackground,
  }
  return colours[colour.toLowerCase()]
}

const HeaderSize = ({ headingSize, heading, styleClass }) => {
  const TagSize = headingSize
  return (
    <TagSize className={styleClass} id={cleanTitle(heading)}>
      {heading}
    </TagSize>
  )
}

export const LandingPageHeading: React.FC<Props> = ({
  title,
  headline,
  bodyCopy,
  backgroundColourOptional,
  headingSize,
  trackingModule,
}) => {
  const { modulePosition } = trackingModule
  const containerClass = `${container} ${getBackgroundColour(
    backgroundColourOptional || "White"
  )}`
  return (
    <>
      <div
        className={containerClass}
        data-testid={title}
        style={{ backgroundColor: backgroundColourOptional }}
      >
        <HeaderSize
          headingSize={modulePosition === 1 ? "h1" : "h2"}
          heading={headline}
          styleClass={
            headingSize === "Small" ? smallHeadingClass : headingClass
          }
        />

        {bodyCopy && isDocument(bodyCopy) && (
          <RichTextRenderer content={bodyCopy} />
        )}
        {bodyCopy && typeof bodyCopy === "string" && (
          <RichTextFlat content={bodyCopy as string} />
        )}
      </div>
    </>
  )
}
